export default __webpack_public_path__ + "static/media/arrow_forward_black_-19@2x.7315617a.png";